import { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "next/navigation";

import { getIsPricelessShop } from "@selectors/store";

import { useJuneSoEventTracking } from "@stadium/services/june-analytics/hooks/use-june-so-event-tracking";
import { useCreateShopContext } from "@contexts/create-shop-context";

import { InternalButton } from "@sharedComponents/buttons";
import DummyStoreCategories from "@components/dummy-store/menu-categories";

import {
  MENU_CATALOG_SELECTION,
  PRICELESS_SHOP,
  SHOP_CREATION,
  SHOP_CREATION_FLOW,
} from "@constants/june-so";

import styles from "./main.module.scss";

const EditCategories = () => {
  const { category } = useParams();

  const [isEditCategoriesModalOpen, setIsEditCategoriesModalOpen] = useState(false);

  const openEditCategoriesModal = () => setIsEditCategoriesModalOpen(true);
  const closeEditCategoriesModal = () => setIsEditCategoriesModalOpen(false);

  const { trackEvent } = useJuneSoEventTracking({ services: SHOP_CREATION_FLOW });
  const isPricelessShop = useSelector(getIsPricelessShop);

  const { isNewShopCreationFlow } = useCreateShopContext();

  let showEditCategories = isNewShopCreationFlow && category;

  if (!showEditCategories) {
    return "";
  }

  return (
    <div className={styles.editButtonBlock}>
      <InternalButton
        onClick={() => {
          trackEvent({
            componentName: isPricelessShop ? PRICELESS_SHOP : SHOP_CREATION,
            elementPosition: MENU_CATALOG_SELECTION,
            target: "edit",
          });
          openEditCategoriesModal();
        }}
        styleType="primary-outline"
      >
        <span className={styles.editIcon} /> Edit
      </InternalButton>
      {isEditCategoriesModalOpen && (
        <DummyStoreCategories isModal closeModal={closeEditCategoriesModal} />
      )}
    </div>
  );
};

export default EditCategories;
